<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      clip-rule="evenodd"
      d="M10.2563 6.08757C10.4724 6.06107 10.6567 5.91889 10.7373 5.7167L11.3766 4.11202C11.4324 3.97198 11.3179 3.82328 11.1683 3.84134L4.35373 4.6636C4.00275 4.70595 3.70074 4.93171 3.56079 5.25636L2.80857 7.00127L5.8936 6.62279L10.2563 6.08757ZM13.3521 6.08812C13.136 6.06162 12.9516 5.91944 12.8711 5.71725L12.2318 4.11257C12.176 3.97253 12.2905 3.82383 12.4401 3.84189L19.2547 4.66415C19.6056 4.7065 19.9076 4.93226 20.0476 5.25691L20.7998 7.00182L13.3521 6.08812ZM20.7998 7.11006H2.7998V16.6946C2.7998 18.3765 4.16322 19.7399 5.84509 19.7399H17.7545C19.4364 19.7399 20.7998 18.3765 20.7998 16.6946V7.11006ZM15.2 12.0006C15.6418 12.0006 16 12.3588 16 12.8006V14.6006C16 15.0425 15.6418 15.4006 15.2 15.4006C14.7582 15.4006 14.4 15.0425 14.4 14.6006V12.8006C14.4 12.3588 14.7582 12.0006 15.2 12.0006ZM9.30039 12.8006C9.30039 12.3588 8.94222 12.0006 8.50039 12.0006C8.05856 12.0006 7.70039 12.3588 7.70039 12.8006V14.6006C7.70039 15.0425 8.05856 15.4006 8.50039 15.4006C8.94222 15.4006 9.30039 15.0425 9.30039 14.6006V12.8006Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script
  lang="ts"
  setup
>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
